/* eslint-disable func-names, no-underscore-dangle, no-param-reassign, no-unused-expressions */
/*
 * BlockAdBlock 3.2.1
 * Copyright (c) 2015 Valentin Allaire <valentin.allaire@sitexw.fr>
 * Released under the MIT license
 * https://github.com/sitexw/BlockAdBlock
 */
/* Modifications made for eslint + some campaign UI fixes */

import _ from 'underscore';
import type {
  BlockAdBlockConstructor,
  BlockAdBlockEventCallback,
  BlockAdBlockInstance,
  BlockAdBlockLogMessage,
  BlockAdBlockOptions,
} from './types';

const BlockAdBlock = function (this: BlockAdBlockInstance, options?: BlockAdBlockOptions) {
  this._options = {
    checkOnLoad: false,
    resetOnEnd: false,
    loopCheckTime: 50,
    loopMaxNumber: 5,
    baitClass: 'pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad text_ads text-ads text-ad-links',
    baitStyle: 'width: 1px !important; height: 1px !important; position: absolute !important; left: -10000px !important; top: -1000px !important;',
    debug: false,
  };
  this._var = {
    version: '3.2.1',
    bait: null,
    checking: false,
    loop: null,
    loopNumber: 0,
    event: { detected: [], notDetected: [] },
  };
  if (options !== undefined) {
    this.setOption(options);
  }
  const self = this;
  const eventCallback = function () {
    setTimeout(() => {
      if (self._options.checkOnLoad === true) {
        if (self._options.debug === true) {
          self._log('onload->eventCallback', 'A check loading is launched');
        }
        if (self._var.bait === null) {
          self._creatBait();
        }
      }
    }, 0);
  };
  if (window.addEventListener !== undefined) {
    window.addEventListener('load', eventCallback, false);
  } else {
    window.attachEvent('onload', eventCallback);
  }
  this.adBlockOn = undefined;
} as unknown as BlockAdBlockConstructor;
BlockAdBlock.prototype._options = null;
BlockAdBlock.prototype._var = null;
BlockAdBlock.prototype._bait = null;

// eslint-disable-next-line no-unused-vars
BlockAdBlock.prototype._log = function (method: string, message: string) {
  // note: enable following line if you need to debug using console log
  // console.log('[BlockAdBlock][' + method + '] ' + message);
};

BlockAdBlock.prototype.setOption = function (options: BlockAdBlockOptions | string, value?: unknown) {
  if (value !== undefined) {
    const key = options as string;
    options = {};
    options[key] = value;
  }

  const optionValues = options as BlockAdBlockOptions;
  // eslint-disable-next-line
  for (const option in optionValues) {
    this._options[option] = optionValues[option];
    if (this._options.debug === true) {
      this._log('setOption', `The option "${option}" he was assigned to "${optionValues[option]}"`);
    }
  }
  return this;
};

BlockAdBlock.prototype._creatBait = function () {
  const bait = document.createElement('div');
  bait.setAttribute('class', this._options.baitClass);
  bait.setAttribute('style', this._options.baitStyle);
  this._var.bait = window.document.body.appendChild(bait);

  this._var.bait.offsetParent;
  this._var.bait.offsetHeight;
  this._var.bait.offsetLeft;
  this._var.bait.offsetTop;
  this._var.bait.offsetWidth;
  this._var.bait.clientHeight;
  this._var.bait.clientWidth;

  if (this._options.debug === true) {
    this._log('_creatBait', 'Bait has been created');
  }
};
BlockAdBlock.prototype._destroyBait = function () {
  // check before destroy it, to make sure it still attached to the document
  if (this._var.bait && this._var.bait.parentElement) {
    window.document.body.removeChild(this._var.bait);
  }
  this._var.bait = null;

  if (this._options.debug === true) {
    this._log('_destroyBait', 'Bait has been removed');
  }
};

BlockAdBlock.prototype.check = function (loop?: boolean) {
  if (loop === undefined) {
    loop = true;
  }

  if (this._options.debug === true) {
    this._log('check', `An audit was requested ${loop === true ? 'with a' : 'without'} loop`);
  }

  if (this._var.checking === true) {
    if (this._options.debug === true) {
      this._log('check', 'A check was canceled because there is already an ongoing');
    }
    return false;
  }
  this._var.checking = true;

  if (this._var.bait === null) {
    this._creatBait();
  }

  const self = this;
  this._var.loopNumber = 0;
  if (loop === true) {
    this._var.loop = setInterval(() => {
      self._checkBait(loop);
    }, this._options.loopCheckTime);
  }
  setTimeout(() => {
    self._checkBait(loop);
  }, 0);
  if (this._options.debug === true) {
    this._log('check', 'A check is in progress ...');
  }

  return true;
};
BlockAdBlock.prototype._checkBait = function (loop: boolean) {
  let detected = false;

  if (this._var.bait === null) {
    this._creatBait();
  }

  if (window.document.body.getAttribute('abp') !== null
    || this._var.bait.offsetParent === null
    || this._var.bait.offsetHeight === 0
    || this._var.bait.offsetLeft === 0
    || this._var.bait.offsetTop === 0
    || this._var.bait.offsetWidth === 0
    || this._var.bait.clientHeight === 0
    || this._var.bait.clientWidth === 0) {
    detected = true;
  }
  if (window.getComputedStyle !== undefined) {
    const baitTemp = window.getComputedStyle(this._var.bait, null);
    if (baitTemp && (baitTemp.getPropertyValue('display') === 'none' || baitTemp.getPropertyValue('visibility') === 'hidden')) {
      detected = true;
    }
  }

  if (this._options.debug === true) {
    this._log(
      '_checkBait',
      `A check (${this._var.loopNumber + 1}/${this._options.loopMaxNumber} ~${1 + (this._var.loopNumber * this._options.loopCheckTime)}ms) was conducted and detection is ${detected === true ? 'positive' : 'negative'}`
    );
  }

  if (loop === true) {
    this._var.loopNumber = this._var.loopNumber + 1;
    if (this._var.loopNumber >= this._options.loopMaxNumber) {
      this._stopLoop();
    }
  }

  if (detected === true) {
    this._stopLoop();
    this._destroyBait();
    this.emitEvent(true);
    if (loop === true) {
      this._var.checking = false;
    }
  } else if (this._var.loop === null || loop === false) {
    this._destroyBait();
    this.emitEvent(false);
    if (loop === true) {
      this._var.checking = false;
    }
  }
};
BlockAdBlock.prototype._stopLoop = function () {
  clearInterval(this._var.loop);
  this._var.loop = null;
  this._var.loopNumber = 0;

  if (this._options.debug === true) {
    this._log('_stopLoop', 'A loop has been stopped');
  }
};

BlockAdBlock.prototype.emitEvent = function (detected: boolean) {
  this.adBlockOn = detected;
  if (this._options.debug === true) {
    this._log('emitEvent', `An event with a ${detected === true ? 'positive' : 'negative'} detection was called`);
  }

  const fns = this._var.event[(detected === true ? 'detected' : 'notDetected')];
  // eslint-disable-next-line
  for (const i in fns) {
    if (this._options.debug === true) {
      this._log('emitEvent', `Call function ${parseInt(i, 10) + 1}/${fns.length}`);
    }
    if (Object.prototype.hasOwnProperty.call(fns, i)) {
      fns[i]();
    }
  }
  if (this._options.resetOnEnd === true) {
    this.clearEvent();
  }
  return this;
};
BlockAdBlock.prototype.clearEvent = function () {
  this._var.event.detected = [];
  this._var.event.notDetected = [];

  if (this._options.debug === true) {
    this._log('clearEvent', 'The event list has been cleared');
  }
};

BlockAdBlock.prototype.on = function (detected: boolean, fn: BlockAdBlockEventCallback) {
  this._var.event[(detected === true ? 'detected' : 'notDetected')].push(fn);
  if (this._options.debug === true) {
    this._log('on', `A type of event "${detected === true ? 'detected' : 'notDetected'}" was added`);
  }

  return this;
};
BlockAdBlock.prototype.onDetected = function (fn: BlockAdBlockEventCallback) {
  return this.on(true, fn);
};
BlockAdBlock.prototype.onNotDetected = function (fn: BlockAdBlockEventCallback) {
  return this.on(false, fn);
};

// new function added by campaign UI
BlockAdBlock.prototype.getAdBlockOn = function (logMessage?: BlockAdBlockLogMessage) {
  if (this.adBlockOn === undefined) {
    this.check();
    this._checkBait(true);
  }
  if (this.adBlockOn === true && logMessage) {
    logMessage('alerts/adblockwarning', '1');
  }
  return !!this.adBlockOn;
};

BlockAdBlock.prototype.setAdBlockOn = function (detected: boolean) {
  this.adBlockOn = !!detected;
};

window.BlockAdBlock = BlockAdBlock;

if (window.blockAdBlock === undefined) {
  window.blockAdBlock = new BlockAdBlock({
    checkOnLoad: false,
    resetOnEnd: true,
  });
}

function adBlockDetected() {
  _.isFunction(window.blockAdBlock && window.blockAdBlock.setAdBlockOn) &&
    window.blockAdBlock.setAdBlockOn(true);
}

function adBlockNotDetected() {
  // some times window.blockAdBlock would be remove by some add-ons.
  _.isFunction(window.blockAdBlock && window.blockAdBlock.setAdBlockOn) &&
    window.blockAdBlock.setAdBlockOn(false);
}

if (typeof blockAdBlock === 'undefined') {
  window.blockAdBlock.adBlockDetected();
} else {
  window.blockAdBlock.setOption({ debug: true });
  window.blockAdBlock.onDetected(adBlockDetected).onNotDetected(adBlockNotDetected);
}
